<template>
<div></div>
</template>

<script>
export default {
name: "PaymentCardDetails"
}
</script>

<style scoped>

</style>
